/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'EACH_CONFINED_SPACE_HAS_SIGNS_INDICATING_THEY_ARE_A_CONFINED_SP',
              'EACH_CONFINED_SPACE_HAS_THE_APPROPRIATE_PROTECTIONS_TO_ENSURE_N',
              'EACH_CONFINED_SPACE_HAS_AUTHORIZED_ENTRY_ONLY_ACCESS',
              'WORKERS_CONTRACTORS_THAT_ENTER_CONFINED_SPACES_DO_SO_ONLY_WHEN_',
              'WORKERS_CONTRACTORS_THAT_ENTER_CONFINED_SPACES_DO_SO_WHEN_THE_A',
              'WORKERS_CONTRACTORS_WHO_ENTER_THE_CONFINED_SPACES_KNOW_AND_UNDE',
              'RESCUE_EQUIPMENT_READY_FOR_USE_WHEN_A_CONFINED_SPACE_ENTRY_OCCU',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_2: valueSchema,
  },
}
